import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, css, fonts, glyphs, icons, frames } from "../../../Styles";
import { NumberDisplayList, UNIT, EsfStationMCore, EsfStationSizes } from "../..";
import { EsfLocation, StationInfo } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import NewButton from "../../BaseComponents/newButton";
import { ButtonTypes } from "../../../Definitions";
import AnimalNumberDisplay from "../../animalNumberDisplay";

// TODO: testdata


// stations number background: 
const stationNumberSvg = (
  <svg width="80px" height="80px" viewBox="0 0 100 100">
    <g transform="rotate(-90, 50, 50)">
      <path className="stationNumberSvg" d="M100,100 L0,100 A100,100 0 0 1 100,0 Z" />
    </g>
  </svg>
)

interface StationCard_Props {
  station: StationInfo;
  onClick: () => void 
}

export default function StationCard({station, onClick}:StationCard_Props) {
  const { t } = useTranslation()
  const [isSelected, setIsSelected] = useState(false);
  const textRefMotor = useRef<HTMLParagraphElement>(null);
  const textRefGate = useRef<HTMLParagraphElement>(null);
  const [feedMotorLength, setFeedMotorLength] = useState(100); // default fallback
  const [feedGateLength, setFeedGateLength] = useState(100); // default fallback

  useEffect(() => {
    if (textRefMotor.current) {
      const width = textRefMotor.current.offsetWidth;
      setFeedMotorLength(width);
    }
    if (textRefGate.current) {
      const width = textRefGate.current.offsetWidth;
      setFeedGateLength(width);
    }
  }, []);

  // NumberDisplayList: Currently in this section TODO
  const FeedCorrections: JSX.Element = useMemo(() => {
    return (
      <NumberDisplayList
        units={[
          <UNIT content={"Kg"} color={colors.greyPrimary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyPrimary}/>}/>,
          <UNIT content={"Times"} color={colors.greyPrimary}/>
        ]}
        values={[
          0,
          0
        ]}
        headers={["fed today", "uses today"]}
        height="fit-content"
        gridRows="1fr"
        headersColor={colors.greyPrimary}
        valuesColor={colors.greyDarkPrimary}
      />
    )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  // On pen click
  const handleClick = () => {
    setIsSelected((prev) => !prev);
    onClick();
  };

  return (
    <frames.StationCard onClick={handleClick}>
      <div className="station_firstChild_left">

        <div style={{ gridArea: "1/1/2/2"}}>{FeedCorrections}</div>
        <div style={{ gridArea: "2/1/3/2", ...css.seperatorLine, width: "100%", margin: "0px" }} />
        <div style={{ gridArea: "3/1/4/2", display: "flex", justifyContent: "center"}}>
          <AnimalNumberDisplay
            content={"current animal"}
            // animal={} TODO
          />
        </div>
      </div>


      <div style={{ gridArea: "1/2/2/3", backgroundColor: colors.greyLightTertiary, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        
        {/* Station Model */}
        <EsfStationMCore size={EsfStationSizes.small} pins={{ }} /> 
        
        {/* Station Number */}
        <div style={{ position: "absolute", top: "0", right: "0", zIndex: "1" }}>
          {stationNumberSvg}
        </div>
        <div style={{ position: "absolute", top: "0", right: "5px", zIndex: "2", height: "60px", width: "fit-content", display: "flex", flexDirection: "column", alignItems: "end", justifyContent: "center", gap: "3px" }}>
          <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyPrimary }}>Station</p>  
          <p style={{ ...fonts.header, ...fonts.fontSize1, color: colors.greyDarkPrimary }}>{station.name}</p>
        </div>

      </div>
    </frames.StationCard>
  )
}